import { render, staticRenderFns } from "./bussetting-add-or-update.vue?vue&type=template&id=7e4760e6&scoped=true&"
import script from "./bussetting-add-or-update.vue?vue&type=script&lang=js&"
export * from "./bussetting-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./bussetting-add-or-update.vue?vue&type=style&index=0&id=7e4760e6&prod&scoped=true&lang=scss&"
import style1 from "./bussetting-add-or-update.vue?vue&type=style&index=1&id=7e4760e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4760e6",
  null
  
)

export default component.exports